export default class GoogleUtil {
    /**
     * Opens new window/tab on google maps in street view.
     * URL built using instructions at https://developers.google.com/maps/documentation/urls/guide#street-view-action
     * 
     * @param lonLatPnt array with longitude/latitude
     */
    openStreetView(lonLatPnt: number[]) {
        const url = 'https://www.google.com/maps/@?api=1'
            + '&map_action=pano'
            + '&viewpoint=' + lonLatPnt[1] + ',' + lonLatPnt[0];
        // optional URL parameters:
        // heading: Indicates the compass heading of the camera in degrees clockwise from North. Accepted values are from -180 to 360 degrees.
        // pitch: Specifies the angle of the camera. The pitch is specified in degrees from -90 (down) to 90 (up).
        // fov: Determines the horizontal field of view of the image in degrees, with a range of 10 - 100. It defaults to 90.
        console.log("es.util.google.openStreetView", url);
        window.open(url);
    }
    
    /**
     * Opens new window/tab on google maps in directions mode
     * URL built using instructions at https://developers.google.com/maps/documentation/urls/guide#directions-action
     * 
     * @param lonLatPnt array with longitude/latitude
     */
    openDirections(lonLatPnt: number[]) {
        const url = 'https://www.google.com/maps/dir/?api=1'
            + '&destination=' + lonLatPnt[1] + ',' + lonLatPnt[0];
        console.log("es.util.google.openDirections", url);
        window.open(url);
    }
}
